// Centralized contact configuration
// Change these values in one place to update everywhere

export const CONTACT = {
  telegram: {
    username: 'paul_zyy',
    portal: 'https://t.me/+oY3h2MLGCFc5ODI9',
  },
}

// Helper to build a Telegram DM link with pre-filled text
export function telegramDM(text: string): string {
  return `https://t.me/${CONTACT.telegram.username}?text=${encodeURIComponent(text)}`
}
